import Vue from 'vue'

// 无内容占位符
Vue.filter('formatDate', (data) => {
  if (!data) return ''
  return data.split(' ')[0] || data
})

Vue.filter('removeHtml', (data) => {
  if (!data) return ''
  return data.replace('.html', '')
})
